var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-header-h5"},[_c('el-menu',{staticClass:"nav-menu",class:[_vm.style],attrs:{"default-active":_vm.activeIndex,"mode":"horizontal"}},[_c('el-menu-item',{attrs:{"index":"0","disabled":""}},[_c('img',{staticClass:"josh-logo",attrs:{"src":require("@/assets/public/logo.png")}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f68404","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/H5/components/NavBar.vue
// module id = null
// module chunks = 